// extracted by mini-css-extract-plugin
module.exports = {"email_manager":"email-manager_email_manager__ZWw6M","card":"email-manager_card__JCj4H"};